/** Portal de tickets de suporte (abre em novo separador). */
export const ADMIN_SUPPORT_TICKETS_URL =
  (import.meta.env.VITE_SUPPORT_TICKETS_URL as string | undefined)?.trim() ||
  'https://suportedigital.solonline.pt/ag%C3%AAncia-solonline/tickets'
